import {
  type LocationInfo,
  type PreloadModuleInfo,
  IPageDefine,
  IPageSetupResource,
  injectable,
} from '@meego-remote/core/app/contract'
import { RouterPattern, RouterKey } from '#setup/contract'

interface PageParam {
  project: string;
}

/** 各组件开发时的非线上数据 Storybook 路由 */
@injectable({ implements: [IPageDefine] })
export class StorybookPageDefine implements IPageDefine {
  public key = RouterKey.StorybookPage


  public pathPattern = [
    RouterPattern.StorybookLayout,
    RouterPattern.StorybookPage,
  ]

  public parseParams(loc: LocationInfo, matchPattern: string, queryParam: PageParam): PageParam {
    return queryParam
  }
}

@injectable()
export class StorybookResource extends IPageSetupResource {
  public pageKey = RouterKey.StorybookPage

  public getPreloadModuleFast() {
    return [
      /** 预拉取 module federation expose 资源 */
      {
        type: 'module',
        key: '@meego-remote/setting',
        m: './playground/setup',
      },
      {
        type: 'module',
        key: '@meego-remote/setting',
        m: './playground/service',
      },
    ] as PreloadModuleInfo[]
  }

  public async getPreloadModule(): Promise<PreloadModuleInfo[]> {
    return []
  }
}
